import React from "react";

interface SummaryCardProps {
    title: string;
    value: string;
}

// ─── Reusable Summary Card Component ───────────────────────────────────────────
// Compact card — title and value are close together, no awkward vertical gap.
export const SummaryCard: React.FC<SummaryCardProps> = ({ title, value }) => {
    return (
        <div
            className="
                bg-neutral-900 
                border border-neutral-800 
                rounded-xl 
                px-4 py-3
                flex flex-col gap-2
                w-full 
                hover:border-neutral-700 
                hover:bg-neutral-900/80 
                transition-all duration-200 
                shadow-sm
                overflow-hidden
            "
        >
            {/* Card Title (uppercase, small, muted color) */}
            <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider leading-tight">
                {title}
            </p>

            {/* Card Value — bigger & consistent font size */}
            <p
                className="text-2xl font-bold text-white whitespace-nowrap"
                title={value}
            >
                {value}
            </p>
        </div>
    );
};